<template>
    <section id="services" class="section-padding">
        <div class="section-header text-center">
            <h2>Nuestros <span>Servicios</span></h2>
        </div>
        <consignacionServicio
        :servicio="servicios[0]"
        />
        <div class="space-80"></div>
        <comprarServicio
            :servicio="servicios[1]"
        />
        <div class="space-80"></div>
        <financiacionServicio
            :servicio="servicios[2]"
        />
        <div class="space-80"></div>
        <retomaServicio
            :servicio="servicios[3]"
        />
    </section>
</template>

<script>
import consignacionServicio from "./consignacionServicio";
import comprarServicio from "./comprarServicio";
import financiacionServicio from "./financiacionServicio";
import retomaServicio from "./retomaServicio";

export default {
    props: {
        servicios: Array,
    },
    mounted() {
        console.log(this.servicios);
    },
    components: {
        consignacionServicio,
        comprarServicio,
        financiacionServicio,
        retomaServicio
    }
};
</script>

<style lang="scss" scoped></style>
